
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import { MONEY as settingMoney, priceOptions, quantityOptions } from "@/modules/Application";
import "vue-select/dist/vue-select.css";
import _ from "lodash";
import { mapGetters } from "vuex";
import { onboardStore } from "../../../onboardStore";
import Plus from "vue-material-design-icons/PlusThick.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";

export default {
  name: "app-produtos-form",
  props: {
    url: {
      type: String,
    },
    variacao: {
      type: Object,
      default: () => { },
    },
  },
  components: {
    Plus,
    TrashCanIcon,
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      onboardStore,
      configMoney: settingMoney,
      quantityOptions,
      priceOptions,
      windowWidth: window.innerWidth,
      exibirCores: false,
      tabIndex: 0,
      selectedTemplate: null,
      templatesExamples: [],
      keyToRender: 0,
      form: {
        nome: null,
        variaveis: [],
        utiliza_cor: false,
      },
      fields: [
        {
          label: "Item/Cód",
          field: "item",
          slot: true,
          sortable: false,
          width: "5%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Nome",
          field: "descricao",
          slot: true,
          sortable: false,
          width: "40%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Qtd",
          field: "quantidade",
          slot: true,
          sortable: false,
          width: "8%",
        },
        {
          label: "Unitário",
          field: "preco",
          sortable: false,
          slot: true,
          width: "10%",
        },
        {
          label: "Total",
          field: "total",
          sortable: false,
          slot: true,
          width: "20%",
        },
        {
          label: "",
          field: "actions",
          sortable: false,
          slot: true,
          width: "10%",
        },
      ],
    };
  },
  watch: {
    variacao: {
      handler(newValue) {
        this.form = { ...newValue }
      }, deep: true
    }
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  created() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  methods: {
    addVariavel() {
      this.form.variaveis = [
        ...this.form.variaveis,
        {
          nome: null,
          ...(this.form.utiliza_cor && { cor: null })
        }
      ]
    },
    excluir(index) {
      const aux = [...this.form.variaveis];
      aux.splice(index, 1);
      this.form.variaveis = [...aux];
    },
    importarTemplate() {
      this.form = this.selectedTemplate;
      this.selectedTemplate = null;
      this.$bvModal.hide('importarTemplate');
    },
    handleEnter(ref) {
      if (this.fromSelect) {
        this.fromSelect = false;
        return;
      }
      if (!this.$refs[ref]) return
      this.$refs[ref].$el.focus();
    },
    handleCheckboxColor() {
      this.form.utiliza_cor = !this.form.utiliza_cor;
      if (this.form.utiliza_cor) {
        this.form.variaveis = this.form.variaveis.map(variavel => ({
          ...variavel,
          cor: variavel?.cor ?? '#000000'
        }))
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    async getDataInit() {
      try {
        const { data } = await this.$http.post('/variavel/tamplates')
        this.templatesExamples = data.map(el => el.tamplate);
      } catch (error) {
        console.log(error);
      }
    },

    async onSubmit() {
      this.addLoadingToButton('submit_nova_variacao');
      try {

        await this.$http.post(this.url, this.form);
        this.$router.push({ name: "variacoes" });
      } catch (err) {
        console.log(err);
      }
      this.removeLoadingToButton('submit_nova_variacao');
    },

  },
};
